<template>
  <div class="container">
      <main>
        <div class="head">
            <div class="title">厂商角色</div>
            <div class="head-right">
                <el-select v-model="groupId" placeholder="请选择厂商" @change="selectChange">
                    <el-option
                    v-for="item in groupList"
                    :key="item.id"
                    :label="item.shortName"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-button type="success" icon="el-icon-plus" style="height:38px" size="small" @click="add">新增角色</el-button>
            </div>
        </div>
        <div class="main-main">
            <div class="left">
                <ul class="roleul">
                    <li v-for="(item,i) in roleList" :key="i">
                        <p @click="checkRole(item)">{{item.name}}</p>
                        <i class="el-icon-edit-outline" style="fontSize:19px;color:#000" @click="edit(item)"></i>
                    </li>
                </ul>
            </div>
            <div class="right">
                <div class="right-list">
                    <el-tree
                    :data="allModuleList"
                    show-checkbox
                    node-key="id"
                    :default-expanded-keys="jueseModuleList"
                    :default-checked-keys="jueseModuleList"
                    ref="tree"
                    @check-change="treeCheck"
                    :props="defaultProps">
                    </el-tree>
                </div>
                <el-popconfirm
                    title="确定保存吗？"
                    @confirm="save"
                >
                    <el-button type="primary" icon="el-icon-check" slot="reference" class="savebtn">保 存</el-button>
                </el-popconfirm>
            </div>
        </div>
      </main>
      <el-dialog :title="isEdit?'编辑':'新增'" :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:50%;margin:0 auto;marginTop:-30px">
        <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules" >
            <el-form-item label="角色名称" label-width="80px" prop="name">
                <el-input v-model="dialogForm.name" placeholder="请输入角色名称" style="width:62%"></el-input>
            </el-form-item>
            <el-form-item label="系统角色" label-width="80px" prop="systemRole">
                <el-select  v-model="dialogForm.systemRole" >
                    <el-option label="管理员"  value='1'></el-option>
                    <el-option label="生产经营" value='2'></el-option>
                    <el-option label="生产管理" value='3'></el-option>
                    <el-option label="财务人员" value='4'></el-option>
                    <el-option label="售后专员" value='5'></el-option>
                    <el-option label="网点经理" value='6'></el-option>
                    <el-option label="普通人员" value='7'></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 10000,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                name: '',
                remark: '',
                groupId: 1,
                systemRole: '1',
            },
            formRules:{
                name:[{
                    required: true,
                    message: "请输入厂商名称",
                    trigger: "blur"
                }],
                remark:[{
                    required: true,
                    message: "请输入角色名称",
                    trigger: "blur"
                }],
            },
            defaultProps: {
                children: 'children',
                label: 'title'
            },
            pageTotal: 1,
            groupList: [],
            groupId: 1,
            roleId: 1,
            roleList: [],
            isEdit: false,
            dialogFormVisible: false,
            checked1: true,
            allModuleList: [],
            jueseModuleList: [],
            treeCheckList: [],
        }
    },
    methods:{
        //获取厂商列表
        getGroupList(option){
            this.$api.GroupList(option).then(res=>{
                this.groupList = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //获取厂商角色
        getRoleList(option){
            this.$api.RoleList({id: option}).then(res=>{
                this.roleList = res.data.data.data;
                this.getRoleModuleIds(this.roleList[0].id);
                this.roleId = this.roleList[0].id;
            })
        },
        //下拉框改变
        selectChange(){
            this.getRoleList(this.groupId);
            this.$nextTick(()=>{
                var doc = document.querySelectorAll('.roleul li p');
                for(let i=0; i< doc.length; i++){
                    doc[i].style.color = '#000';
                }
            })
        },
        //获取所有功能模块
        async getAllModuleList(){
            this.$api.GetAllModuleList().then(res=>{
                this.allModuleList = JSON.parse(res.data.data);
            })
        },
        //获取角色功能模块
        getRoleModuleIds(option){
            this.getAllModuleList().then(()=>{
                this.$api.RoleModuleIds({id: option}).then(res=>{
                    this.jueseModuleList = res.data.data;
                })
            })
        },
        //树形图改变
        treeCheck(){
            this.treeCheckList = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())  
        },
        //点击角色
        checkRole(item){
            this.jueseModuleList = [];
            this.getRoleModuleIds(item.id);
            this.roleId = item.id;
            this.$nextTick(()=>{
                var doc = document.querySelectorAll('.roleul li p');
                for(let i=0; i< doc.length; i++){
                    doc[i].style.color = '#000';
                    if(doc[i].innerHTML === item.name){
                        doc[i].style.color = '#409EFF';
                    }
                }
            })
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                name: '',
                remark: '',
                groupId: this.groupId,
                systemRole: '1',
            }
        },
        //编辑按钮
        edit(row){
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: row.id,
                name: row.name,
                remark: row.remark,
                groupId: row.groupId,
                systemRole: String(row.systemRole)
            }
        },
        save(){
            this.$api.AddRoleModules({
                roleId: this.roleId,
                moduleIds: this.treeCheckList.join(),
                groupId: this.groupId
            }).then(res=>{
                if(res.data.code == 200){
                    this.$notify({
                        message: res.data.msg,
                        type: 'success'
                    })
                }else{
                    this.$notify({
                        message: res.data.msg,
                        type: 'error'
                    })
                }
            })
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    this.dialogForm.systemRole = Number(this.dialogForm.systemRole)
                    if(this.isEdit){
                        this.$api.UpdateRole(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getRoleList(this.groupId);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }else{
                        this.$api.AddRole(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getRoleList(this.groupId);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    };
                    this.dialogFormVisible = false;
                }
            })
        }
    },
    mounted(){
        this.getGroupList(this.option);
        this.getRoleList(this.groupId);
        this.getAllModuleList();
    },
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
.head{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
    .title{
        font-weight: bold;
        margin-top: -1%;
        margin-left: 0.5%;
    }
    .head-right{
        width: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .el-select{
        width: 72% !important;
    }
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
.main-main{
    height: 92%;
    display: flex;
}
.left{
    width: 20%;
}
.right{
    border: 1px solid #eee;
    border-left: none;
    flex: 1;
    display: flex;
}
.roleul{
    border: 1px solid #eee;
    height: 100%;
    padding: 0 10px;
    overflow: auto;
    li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 5%;
        border-bottom: 1px solid #eee;
        cursor: pointer;
        font-size: 0.9375rem;
        padding: 0 5px;
    }
    
}
.right-list{
    border-right: 1px solid #eee;
    width: 40%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-content: flex-start;
}
.el-tree-node__label{
    font-size: 18px !important;
}
.savebtn{
    height: 6%;
    width: 7.5rem;
    margin: 0.625rem;
}
</style>